var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"rounded p-1 border border-primary d-flex flex-row align-items-center",staticStyle:{"background-color":"#409eff22"}},[_c('i',{staticClass:"el-icon-info text-primary"}),_c('small',{staticClass:"ml-1"},[_vm._t("default")],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }